// import { useEffect, useMemo, useState } from "react";
// import styles from "./ShareModal.module.css";
// import { useGetChatsQuery, useSendMessageMutation } from "../store/api/chatApi";
// import { useSharePostMutation } from "../store/api/postApi";
// import { toast } from "react-toastify";

// export default function ShareModal({ isOpen, onClose, post }) {
//   const { data: chats = [], isLoading } = useGetChatsQuery(undefined, {
//     skip: !isOpen,
//   });

//   const [sharePostToFeed, { isLoading: isSharingToFeed }] =
//     useSharePostMutation();

//   const [caption, setCaption] = useState("");

//   const [sendMessage, { isLoading: isSending }] = useSendMessageMutation();
//   const [selectedUsers, setSelectedUsers] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [done, setDone] = useState(false);

//   // ✅ This is the link that will be sent in chat
//   const postLink = `${window.location.origin}/post/${post?.id}`;

//   useEffect(() => {
//     if (!isOpen) {
//       setSelectedUsers([]);
//       setSearchQuery("");
//       setDone(false);
//     }
//   }, [isOpen]);

//   const filteredChats = useMemo(() => {
//     if (!searchQuery.trim()) return chats;
//     return chats.filter((c) =>
//       c.userName?.toLowerCase().includes(searchQuery.toLowerCase()),
//     );
//   }, [chats, searchQuery]);

//   const toggleUser = (id) => {
//     setSelectedUsers((prev) =>
//       prev.includes(id) ? prev.filter((u) => u !== id) : [...prev, id],
//     );
//   };

//   const handleShare = async () => {
//     if (selectedUsers.length === 0) return;
//     try {
//       await Promise.all(
//         selectedUsers.map((receiverId) =>
//           sendMessage({
//             receiverId,
//             message: postLink, // ✅ sends the link as plain text message
//           }).unwrap(),
//         ),
//       );

//       toast.success("Post shared successfully");
//       setDone(true);
//       setTimeout(() => onClose(), 1200);
//     } catch (error) {
//       console.error("Share failed:", error);
//       toast.error("Failed to share. Please try again.");
//     }
//   };

//   const handleFeedShare = async () => {
//     try {
//       await sharePostToFeed({
//         originalPostId:
//           post.type === "SharedPost" ? post.originalPost?.id : post.id,
//         caption,
//       }).unwrap();

//       toast.success("Post shared to feed successfully");
//       setDone(true);
//       setTimeout(() => onClose(), 1200);
//     } catch (error) {
//       console.error("Feed share failed:", error);
//       toast.error("Failed to share to feed.");
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className={styles.overlay} onClick={onClose}>
//       <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
//         {/* HEADER */}
//         <div className={styles.header}>
//           <h3>Share Post</h3>
//           <button className={styles.closeBtn} onClick={onClose}>
//             ✕
//           </button>
//         </div>

//         {/* CAPTION (for Feed Share only) */}
//         <div className={styles.captionBox}>
//           <textarea
//             placeholder="Add a caption to your post..."
//             value={caption}
//             onChange={(e) => setCaption(e.target.value)}
//             className={styles.captionInput}
//           />
//         </div>

//         {/* USER LIST (Chat Share — unchanged) */}
//         <div className={styles.userList}>
//           {isLoading ? (
//             <p className={styles.emptyText}>Loading connections...</p>
//           ) : filteredChats.length === 0 ? (
//             <p className={styles.emptyText}>
//               {searchQuery ? "No results found" : "No connections yet"}
//             </p>
//           ) : (
//             filteredChats.map((chat) => {
//               const isSelected = selectedUsers.includes(chat.otherUserId);
//               return (
//                 <div
//                   key={chat.otherUserId}
//                   className={`${styles.userRow} ${isSelected ? styles.selected : ""}`}
//                   onClick={() => toggleUser(chat.otherUserId)}
//                 >
//                   {chat.profilePhotoUrl ? (
//                     <img
//                       src={chat.profilePhotoUrl}
//                       alt=""
//                       className={styles.avatar}
//                     />
//                   ) : (
//                     <div className={styles.avatarFallback}>
//                       {chat.userName?.[0] ?? "?"}
//                     </div>
//                   )}
//                   <div className={styles.userInfo}>
//                     <span className={styles.userName}>{chat.userName}</span>
//                     {chat.lastMessageText && (
//                       <span className={styles.lastMsg}>
//                         {chat.lastMessageText.slice(0, 35)}...
//                       </span>
//                     )}
//                   </div>
//                   <input
//                     type="checkbox"
//                     checked={isSelected}
//                     readOnly
//                     className={styles.checkbox}
//                   />
//                 </div>
//               );
//             })
//           )}
//         </div>

//         {/* FOOTER */}
//         <div className={styles.footer}>
//           {done ? (
//             <span className={styles.successText}>✓ Shared Successfully!</span>
//           ) : (
//             <>
//               {/* 🔁 Share to Feed Button (NEW) */}
//               <button
//                 className={styles.feedShareBtn}
//                 onClick={handleFeedShare}
//                 disabled={isSharingToFeed}
//               >
//                 {isSharingToFeed ? "Sharing..." : "Share to Feed"}
//               </button>

//               {/* Chat Share Section (UNCHANGED) */}
//               <span className={styles.selectedCount}>
//                 {selectedUsers.length > 0
//                   ? `${selectedUsers.length} selected`
//                   : "Select people to share with"}
//               </span>

//               <button
//                 className={styles.shareBtn}
//                 onClick={handleShare}
//                 disabled={selectedUsers.length === 0 || isSending}
//               >
//                 {isSending ? "Sending..." : `Send (${selectedUsers.length})`}
//               </button>
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }



import { useEffect, useMemo, useState } from "react";
import styles from "./ShareModal.module.css";
import { useGetChatsQuery, useSendMessageMutation } from "../store/api/chatApi";
import { useSharePostMutation } from "../store/api/postApi";
import { toast } from "react-toastify";

// ── SVG brand icons ──────────────────────────────────────────────────────────
const ICONS = {
  whatsapp: (
    <svg viewBox="0 0 32 32" width="28" height="28" fill="none">
      <circle cx="16" cy="16" r="16" fill="#25D366"/>
      <path fill="#fff" d="M23.5 8.5A10.45 10.45 0 0 0 16 5.5C10.2 5.5 5.5 10.2 5.5 16c0 1.85.48 3.65 1.4 5.24L5.5 26.5l5.42-1.42A10.44 10.44 0 0 0 16 26.5c5.8 0 10.5-4.7 10.5-10.5 0-2.8-1.09-5.43-3-7.5zM16 24.55a8.6 8.6 0 0 1-4.38-1.2l-.31-.19-3.22.84.86-3.14-.2-.32A8.55 8.55 0 0 1 7.45 16c0-4.72 3.84-8.55 8.55-8.55 2.28 0 4.42.89 6.03 2.5a8.5 8.5 0 0 1 2.5 6.05c0 4.72-3.83 8.55-8.53 8.55zm4.69-6.4c-.26-.13-1.52-.75-1.75-.83-.24-.09-.41-.13-.58.13-.17.25-.65.83-.8 1-.15.17-.3.19-.55.06-.26-.13-1.08-.4-2.06-1.27-.76-.68-1.27-1.52-1.42-1.77-.15-.26-.01-.4.11-.52.12-.11.26-.3.39-.44.13-.15.17-.26.26-.43.08-.17.04-.32-.02-.44-.07-.13-.58-1.4-.8-1.91-.21-.5-.43-.43-.58-.44h-.5c-.17 0-.44.06-.67.32-.23.25-.88.86-.88 2.1s.9 2.43 1.03 2.6c.13.17 1.77 2.7 4.29 3.79.6.26 1.07.41 1.43.53.6.19 1.15.16 1.58.1.48-.07 1.48-.6 1.69-1.19.2-.58.2-1.08.14-1.19-.07-.1-.24-.16-.5-.28z"/>
    </svg>
  ),
  facebook: (
    <svg viewBox="0 0 32 32" width="28" height="28" fill="none">
      <circle cx="16" cy="16" r="16" fill="#1877F2"/>
      <path fill="#fff" d="M21.5 16h-3.5v10h-4V16h-2v-3.5h2v-2c0-2.76 1.14-4.5 4.5-4.5H21v3.5h-2c-.83 0-1 .33-1 .83V12.5h3.5L21.5 16z"/>
    </svg>
  ),
  twitter: (
    <svg viewBox="0 0 32 32" width="28" height="28" fill="none">
      <circle cx="16" cy="16" r="16" fill="#000"/>
      <path fill="#fff" d="M17.75 14.77 23.3 8h-1.32l-4.82 5.6L13.18 8H8.5l5.83 8.48L8.5 24h1.32l5.1-5.93L18.82 24H23.5l-5.75-9.23zm-1.8 2.1-.59-.84-4.7-6.72h2.02l3.79 5.42.59.84 4.93 7.06h-2.02l-4.02-5.76z"/>
    </svg>
  ),
  linkedin: (
    <svg viewBox="0 0 32 32" width="28" height="28" fill="none">
      <circle cx="16" cy="16" r="16" fill="#0A66C2"/>
      <path fill="#fff" d="M10.5 13h-3v9.5h3V13zm-1.5-4.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM24.5 22.5h-3v-4.75c0-1.13-.02-2.58-1.57-2.58-1.58 0-1.82 1.23-1.82 2.5v4.83h-3V13h2.88v1.36h.04c.4-.76 1.38-1.56 2.84-1.56 3.04 0 3.6 2 3.6 4.6v5.1z"/>
    </svg>
  ),
  telegram: (
    <svg viewBox="0 0 32 32" width="28" height="28" fill="none">
      <circle cx="16" cy="16" r="16" fill="#0088CC"/>
      <path fill="#fff" d="M23.5 8.9 20.74 22.4c-.2.9-.74 1.12-1.5.7l-4.16-3.06-2 1.93c-.22.22-.41.41-.85.41l.3-4.26 7.8-7.04c.34-.3-.07-.47-.52-.17L8.73 17.57 4.67 16.3c-.9-.28-.92-.9.2-1.33l17.6-6.79c.74-.27 1.39.18 1.03 1.72z"/>
    </svg>
  ),
  instagram: (
    <svg viewBox="0 0 32 32" width="28" height="28" fill="none">
      <defs>
        <radialGradient id="ig1" cx="30%" cy="107%" r="150%">
          <stop offset="0%" stopColor="#fdf497"/>
          <stop offset="5%" stopColor="#fdf497"/>
          <stop offset="45%" stopColor="#fd5949"/>
          <stop offset="60%" stopColor="#d6249f"/>
          <stop offset="90%" stopColor="#285AEB"/>
        </radialGradient>
      </defs>
      <circle cx="16" cy="16" r="16" fill="url(#ig1)"/>
      <rect x="9" y="9" width="14" height="14" rx="4" stroke="#fff" strokeWidth="1.8" fill="none"/>
      <circle cx="16" cy="16" r="3.5" stroke="#fff" strokeWidth="1.8" fill="none"/>
      <circle cx="20.5" cy="11.5" r="1" fill="#fff"/>
    </svg>
  ),
  copy: (
    <svg viewBox="0 0 32 32" width="28" height="28" fill="none">
      <circle cx="16" cy="16" r="16" fill="#f0f4f7"/>
      <path stroke="#5a7282" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none"
        d="M13 19a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2M14 23h5a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2z"/>
    </svg>
  ),
  copyDone: (
    <svg viewBox="0 0 32 32" width="28" height="28" fill="none">
      <circle cx="16" cy="16" r="16" fill="#f0fdf4"/>
      <path stroke="#1d9e75" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"
        d="M10 16l4 4 8-8"/>
    </svg>
  ),
};

// ── External share component ──────────────────────────────────────────────────
function ExternalShare({ postLink, postCaption }) {
  const [copied, setCopied] = useState(false);

  const text = postCaption
    ? `${postCaption.slice(0, 80)}${postCaption.length > 80 ? '...' : ''} — via Nessefy`
    : 'Check this out on Nessefy';

  const encodedLink = encodeURIComponent(postLink);
  const encodedText = encodeURIComponent(text);

  const apps = [
    {
      name: 'WhatsApp',
      icon: ICONS.whatsapp,
      color: '#25D366',
      url: `https://api.whatsapp.com/send?text=${encodedText}%20${encodedLink}`,
    },
    {
      name: 'Facebook',
      icon: ICONS.facebook,
      color: '#1877F2',
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedLink}`,
    },
    {
      name: 'Twitter/X',
      icon: ICONS.twitter,
      color: '#000000',
      url: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedLink}`,
    },
    {
      name: 'Instagram',
      icon: ICONS.instagram,
      color: '#E1306C',
      url: `https://www.instagram.com/`,
    },
    {
      name: 'LinkedIn',
      icon: ICONS.linkedin,
      color: '#0A66C2',
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedLink}`,
    },
    {
      name: 'Telegram',
      icon: ICONS.telegram,
      color: '#0088CC',
      url: `https://t.me/share/url?url=${encodedLink}&text=${encodedText}`,
    },
  ];

  const handleAppShare = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer,width=600,height=500');
  };

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: 'Nessefy Post', text, url: postLink });
      } catch (e) {}
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(postLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      const el = document.createElement('textarea');
      el.value = postLink;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const btnStyle = (color) => ({
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    gap: 5, padding: '8px 10px',
    border: '1.5px solid transparent',
    borderRadius: 14, background: 'transparent',
    cursor: 'pointer', fontSize: '0.68rem', fontWeight: 600,
    color: '#5a7282', fontFamily: 'inherit',
    transition: 'all 0.18s', minWidth: 58,
  });

  return (
    <div style={{ padding: '12px 16px', borderBottom: '1px solid #f0f4f7' }}>
      <p style={{
        fontSize: '0.72rem', fontWeight: 700, color: '#9bb0bc',
        textTransform: 'uppercase', letterSpacing: '0.07em', margin: '0 0 10px'
      }}>
        Share to
      </p>

      <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', alignItems: 'flex-start' }}>

        {/* Native share — mobile only */}
        {typeof navigator !== 'undefined' && navigator.share && (
          <button onClick={handleNativeShare} style={btnStyle()}>
            <svg viewBox="0 0 32 32" width="28" height="28" fill="none">
              <circle cx="16" cy="16" r="16" fill="#f0f4f7"/>
              <path stroke="#5a7282" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none"
                d="M20 10l-4-4-4 4M16 6v12M10 18v4h12v-4"/>
            </svg>
            More
          </button>
        )}

        {apps.map(app => (
          <button
            key={app.name}
            onClick={() => handleAppShare(app.url)}
            style={btnStyle(app.color)}
            onMouseEnter={e => {
              e.currentTarget.style.background = `${app.color}12`;
              e.currentTarget.style.borderColor = `${app.color}40`;
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.borderColor = 'transparent';
            }}
          >
            {app.icon}
            {app.name}
          </button>
        ))}

        {/* Copy link */}
        <button
          onClick={handleCopy}
          style={{
            ...btnStyle(),
            color: copied ? '#1d9e75' : '#5a7282',
          }}
        >
          {copied ? ICONS.copyDone : ICONS.copy}
          {copied ? 'Copied!' : 'Copy Link'}
        </button>

      </div>
    </div>
  );
}

export default function ShareModal({ isOpen, onClose, post }) {
  const { data: chats = [], isLoading } = useGetChatsQuery(undefined, {
    skip: !isOpen,
  });

  const [sharePostToFeed, { isLoading: isSharingToFeed }] =
    useSharePostMutation();

  const [caption, setCaption] = useState("");

  const [sendMessage, { isLoading: isSending }] = useSendMessageMutation();
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [done, setDone] = useState(false);

  // ✅ This is the link that will be sent in chat
  const postLink = `${window.location.origin}/post/${post?.id}`;

  useEffect(() => {
    if (!isOpen) {
      setSelectedUsers([]);
      setSearchQuery("");
      setDone(false);
    }
  }, [isOpen]);

  const filteredChats = useMemo(() => {
    if (!searchQuery.trim()) return chats;
    return chats.filter((c) =>
      c.userName?.toLowerCase().includes(searchQuery.toLowerCase()),
    );
  }, [chats, searchQuery]);

  const toggleUser = (id) => {
    setSelectedUsers((prev) =>
      prev.includes(id) ? prev.filter((u) => u !== id) : [...prev, id],
    );
  };

  const handleShare = async () => {
    if (selectedUsers.length === 0) return;
    try {
      await Promise.all(
        selectedUsers.map((receiverId) =>
          sendMessage({
            receiverId,
            message: postLink, // ✅ sends the link as plain text message
          }).unwrap(),
        ),
      );

      toast.success("Post shared successfully");
      setDone(true);
      setTimeout(() => onClose(), 1200);
    } catch (error) {
      console.error("Share failed:", error);
      toast.error("Failed to share. Please try again.");
    }
  };

  const handleFeedShare = async () => {
    try {
      await sharePostToFeed({
        originalPostId:
          post.type === "SharedPost" ? post.originalPost?.id : post.id,
        caption,
      }).unwrap();

      toast.success("Post shared to feed successfully");
      setDone(true);
      setTimeout(() => onClose(), 1200);
    } catch (error) {
      console.error("Feed share failed:", error);
      toast.error("Failed to share to feed.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        {/* HEADER */}
        <div className={styles.header}>
          <h3>Share Post</h3>
          <button className={styles.closeBtn} onClick={onClose}>
            ✕
          </button>
        </div>

        {/* ── EXTERNAL SHARE (WhatsApp, Facebook, etc.) ── */}
        <ExternalShare postLink={postLink} postCaption={post?.caption} />

        {/* CAPTION (for Feed Share only) */}
        <div className={styles.captionBox}>
          <textarea
            placeholder="Add a caption to your post..."
            value={caption}
            onChange={(e) => setCaption(e.target.value)}
            className={styles.captionInput}
          />
        </div>

        {/* USER LIST (Chat Share — unchanged) */}
        <div className={styles.userList}>
          {isLoading ? (
            <p className={styles.emptyText}>Loading connections...</p>
          ) : filteredChats.length === 0 ? (
            <p className={styles.emptyText}>
              {searchQuery ? "No results found" : "No connections yet"}
            </p>
          ) : (
            filteredChats.map((chat) => {
              const isSelected = selectedUsers.includes(chat.otherUserId);
              return (
                <div
                  key={chat.otherUserId}
                  className={`${styles.userRow} ${isSelected ? styles.selected : ""}`}
                  onClick={() => toggleUser(chat.otherUserId)}
                >
                  {chat.profilePhotoUrl ? (
                    <img
                      src={chat.profilePhotoUrl}
                      alt=""
                      className={styles.avatar}
                    />
                  ) : (
                    <div className={styles.avatarFallback}>
                      {chat.userName?.[0] ?? "?"}
                    </div>
                  )}
                  <div className={styles.userInfo}>
                    <span className={styles.userName}>{chat.userName}</span>
                    {chat.lastMessageText && (
                      <span className={styles.lastMsg}>
                        {chat.lastMessageText.slice(0, 35)}...
                      </span>
                    )}
                  </div>
                  <input
                    type="checkbox"
                    checked={isSelected}
                    readOnly
                    className={styles.checkbox}
                  />
                </div>
              );
            })
          )}
        </div>

        {/* FOOTER */}
        <div className={styles.footer}>
          {done ? (
            <span className={styles.successText}>✓ Shared Successfully!</span>
          ) : (
            <>
              {/* 🔁 Share to Feed Button (NEW) */}
              <button
                className={styles.feedShareBtn}
                onClick={handleFeedShare}
                disabled={isSharingToFeed}
              >
                {isSharingToFeed ? "Sharing..." : "Share to Feed"}
              </button>

              {/* Chat Share Section (UNCHANGED) */}
              <span className={styles.selectedCount}>
                {selectedUsers.length > 0
                  ? `${selectedUsers.length} selected`
                  : "Select people to share with"}
              </span>

              <button
                className={styles.shareBtn}
                onClick={handleShare}
                disabled={selectedUsers.length === 0 || isSending}
              >
                {isSending ? "Sending..." : `Send (${selectedUsers.length})`}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}